import { Loader } from '../../../../../../../../components/loader/loader';
import { Select } from '../../../../../../../../components/select/select';
import { DeleteModal } from '../../../../../../../../features/delete-modal/delete-modal';
import { EditableLabel } from '../../../../../../../../features/editable-label/editable-label';
import { Sorter } from '../../../../../../../../features/sorter/sorter';
import { useMenuInformerCreateCategoryModal } from '../../../menu-informer-table/menu-informer-table-header/menu-informer-create-category-modal/use-menu-informer-create-category-modal';
import { MenuInformerCreateUnit } from '../../../menu-informer-table/menu-informer-table-header/menu-informer-create-unit';
import s from './menu-informer-create-menu-modal-step-3.module.css';

export const MenuInformerCreateMenuModalStep3 = () => {
  const {
    categories,
    deleteCategory,
    getLocale,
    handleCreate,
    handleUpdate,
    isLoading,
    section,
    sections,
    setCategoryListOrder,
    setSection,
    language,
    addQueryParams,
    t,
  } = useMenuInformerCreateCategoryModal();

  return (
    <div className={s.feature}>
      {isLoading && <Loader />}
      <Select
        options={sections}
        value={section}
        onSelect={setSection}
        placeholder={t('Выберите раздел')}
        data-testid="section-select"
      />

      <MenuInformerCreateUnit
        placeholder={t('Например, «Салаты» или «Горячие блюда»')}
        name="category"
        onConfirm={handleCreate}
        showLanguageSelect={false}
        isLoading={isLoading}
        data-testid="create-unit"
      />

      <div className={s.inputs}>
        <Sorter
          itemIds={categories?.map((item) => String(item.id))}
          onSort={(e) => section && setCategoryListOrder(e.map(Number), Number(section.id))}
        >
          {categories?.map((item) => (
            <EditableLabel
              key={String(item.id)}
              className={s.item}
              sortable
              id={String(item.id)}
              onDelete={async () => {
                addQueryParams({
                  deleteId: item.id.toString(),
                  deleteName: getLocale(item?.name, language),
                });
              }}
              value={getLocale(item.name, language)}
              onConfirm={(e) => handleUpdate({ ...item, name: { ...item.name, [language]: e } })}
              data-testid={`category-${item.id}`}
            >
              {getLocale(item.name, language)}
            </EditableLabel>
          ))}
        </Sorter>
      </div>
      <DeleteModal onSubmit={deleteCategory} />
    </div>
  );
};
